import React, { Component } from "react";
import { showMainErrorPop } from '../../actions/popups';
import { connect } from "react-redux";
import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class CancelBooking extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={

    }
	
}
 
componentDidMount(){
	axiosVirdio = new axiosVirdioT(this.props);
}

closeCancel=()=>{
	this.props.updateStateFromChild({classBoking: false, sessionToCancel: 0});
}

cancelBookingClass=()=>{
	let mainthis = this;
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	axiosVirdio.put(process.env.REACT_APP_API_URL+"/api/v1/session/"+this.props.sessionId+"/CancelSession").then(res => {
		mainthis.props.cancelSessionStatus(this.props.sessionId);
	 }).catch(err =>{ })	
}

  render() {
	 return (
		<div className="booked_pop_content">
			<div className="booked_container">
				<div className="close_cancel" onClick={this.closeCancel}></div>
				<div className="booked_title">Cancel Booking?</div>
				<div className="booked_bnts_content">
					<div className="inactive_booked_bnt" onClick={this.closeCancel}>No</div>
					<div className="active_booked_bnt" onClick={this.cancelBookingClass}>Yes</div>
				</div>
			</div>
		</div>
    );
  }
}
export default connect(
  null,
  { 
	showMainErrorPop
  }
)(CancelBooking);